export interface StepperProps {
  steps: string[];
}
export const Stepper = ({ steps }: StepperProps) => {
  return (
    <>
      <div className={`grid grid-cols-${steps?.length} w-auto py-4`}>
        {steps?.map((color, index) => (
          <div key={index} className={`border-t-8 border-${color} pt-4`}></div>
        ))}
      </div>
    </>
  );
};
